import { useEffect } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { routes } from '@/routes';
import { useAuthStore } from '@/stores/authStore';
import { useUpdateStore } from '@/stores/updateStore';
import { UpdateGate } from '@/components/UpdateGate';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { ToastHost } from '@/components/ui/Toast';

const router = createBrowserRouter(routes);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: true,
      staleTime: 30_000,
    },
  },
});

export function App() {
  useEffect(() => {
    useAuthStore.getState().hydrate();
    // Register the service worker and begin polling the server for the expected
    // client version (prompt/force update gate).
    useUpdateStore.getState().start();
    // Ask the browser to keep our IndexedDB/Cache durable (avoid eviction of
    // queued logs/media under storage pressure). Best-effort.
    if (typeof navigator !== 'undefined' && navigator.storage?.persist) {
      void navigator.storage.persisted().then((already) => {
        if (!already) void navigator.storage.persist();
      });
    }
  }, []);

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <UpdateGate />
        <ToastHost />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
